import { render, staticRenderFns } from "./DownloadExel.vue?vue&type=template&id=354fcf8e&scoped=true&"
import script from "./DownloadExel.vue?vue&type=script&lang=js&"
export * from "./DownloadExel.vue?vue&type=script&lang=js&"
import style0 from "./DownloadExel.vue?vue&type=style&index=0&id=354fcf8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354fcf8e",
  null
  
)

component.options.__file = "DownloadExel.vue"
export default component.exports